export const SUBDIVISIONS_LOADING = 'SUBDIVISIONS_LOADING';
export const SUBDIVISIONS_SUCCESS = 'SUBDIVISIONS_SUCCESS';
export const SUBDIVISIONS_ERROR = 'SUBDIVISIONS_ERROR';

export const getSubDivisions = () => async (dispatch) => {
  dispatch({ type: SUBDIVISIONS_LOADING });
  try {
    // Adjust endpoint as needed
    const res = await fetch('/api/subDivisions');
    if (!res.ok) throw new Error('Failed to fetch sub-divisions');
    const data = await res.json();
    dispatch({ type: SUBDIVISIONS_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: SUBDIVISIONS_ERROR, error: error.message || error });
    return [];
  }
};

export default getSubDivisions;
